<template>
  <v-app class="container">
    <barra />
    <v-card class="text-center">
      <v-card-title v-if="cargando" class="grey lighten-4 change-font" primary-title>
        <div class="spinner-grow"></div>Cargando puntos &#8230;
      </v-card-title>
      <v-card-title v-else class="grey lighten-4 change-font" primary-title>
        Avances indicadores PMI con clasificación PDET 
        <span
          class="d-none d-md-block"
          style="white-space: pre-wrap;"
        >&nbsp;({{ total }} pilares - {{ totalChilds }} indicadores)</span>
      </v-card-title>
      <v-card-text>
        <br>
        <v-layout v-if="clasificacion">
              <div class="content-title" :style="{ color: clasificacion.color }">
                {{ clasificacion.nombre }}
              </div>
        </v-layout>
        <v-container fluid grid-list-xl>
          <v-layout wrap >
            <v-flex
              style="margin-top:-35px;"
              s12
              sm6
              md4
              v-for="item of withavances"
              v-bind:key="item.idpilar"
            >
              <gaugesimple
                v-bind:nombre="'punto6-' + item.idpilar"
                v-bind:id="item.idpilar"
                v-bind:titulo="item.nombre"
                v-bind:fuente="fuente"
              />
            </v-flex>
            <v-flex
              class="fechacorte"
              xs12
              v-if="gfechacorte!== null"
            >Fecha actualización: {{formato(gfechacorte.fechaactualizacion)}}</v-flex>
            <v-flex
              class="fechacorte"
              xs12
              v-if="gfechacorte!== null"
            >Fecha corte: {{formato(gfechacorte.fechacorte)}}</v-flex>
          </v-layout>
          <v-layout> 
					<v-flex class="pb-0">
            <div class="col text-center pt-0 pb-0 pl-0 mt-4" :hidden="BttonHidden">
              <button type="button" class="v-btn theme--light elevation-2 v-size--xlarge primary w-600" @click="gotoTerritorializacionPDET">
                <span class="v-btn__content">Georreferenciación de los indicadores con desagregación territorial</span>
              </button>
            </div>
					</v-flex>            
          </v-layout>
				         
        </v-container>        
      </v-card-text>
    </v-card>
    <br />
    <v-card id="containera" ref="containera">
      <v-card-title v-if="indicadores.length <= 0" class="grey lighten-4 change-font" primary-title>
        <div class="spinner-grow"></div>Cargando indicadores &#8230;
      </v-card-title>
      <v-card-title
        v-else
        class="grey lighten-4 change-font"
        primary-title
      >Indicadores del {{nombrepunto}}</v-card-title>
      <v-card-text>
        <v-container>
          <v-layout v-if="clasificacion" wrap>
            <br />
            <div v-if="indicadores">
              <v-data-table
                :no-data-text="gnodata"
                :headers="headers"
                :items="indicadores"
                class="elevation-2"
                hide-default
                :items-per-page="10"
              >
                <template v-slot:[`item.action`]="{ item }">
                  <div v-if="item.finalizado === true">
                    <v-icon small class="mr-2" @click="verdetalle(item)">remove_red_eye</v-icon>
                  </div>
                  <div v-else>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon small color="red" class="mr-2" v-on="on">remove_red_eye</v-icon>
                      </template>
                      <span>Sin ficha técnica</span>
                    </v-tooltip>
                  </div>
                </template>
                <template v-slot:[`item.avancemostrar`]="{ item }">
                  <div v-if="item.avancemostrar !== '-'">
                    <span small class="mr-2">{{item.avancemostrar}}</span>
                  </div>
                  <div v-else>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <span v-on="on" class="mr-2">{{item.avancemostrar}}</span>
                      </template>
                      <span>Entidad no registró avance</span>
                    </v-tooltip>
                  </div>
                </template>
                <template v-slot:footer>
                  <div id="div1" style="width:100%;align:right">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <download-excel
                          id="div2"
                          style="width:100%;text-align: right;"
                          v-show="indicadores.length>0"
                          class="btn btn-default"
                          :data="indicadores"
                          :exportFields="exportable"
                          name="indicadores.xls"
                          type="xls"
                          worksheet="Información"
                        >
                          <v-icon
                            color="secondary"
                            v-on="on"
                            large
                            elevation="2"
                          >mdi-file-download-outline</v-icon>
                        </download-excel>
                      </template>
                      <span>Descargar</span>
                    </v-tooltip>
                  </div>
                </template>
              </v-data-table>
               
            </div>
          </v-layout>           
        </v-container>
      </v-card-text>
    </v-card>
  </v-app>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import gaugesimple from "@/components/chart/gaugetermometro.vue";
import barra from "@/components/content/barra-nav.vue";
import moment from "moment";
export default {
  name: "clasificacionpdte-punto",
  components: {
    gaugesimple,
    barra
  },
  props: {
    linkPath: {
      type: String,
      required: false,
      default: "/avance/estrategia/"
    }
  },
  data() {
    return {
      exportable: {
        Código: "codigo",
        Nombre: "nombre",
        Descripción: "descripcion",
        Entidad: "entidades.nombre",
        "Ficha técnica": {
          field: "finalizado",
          callback: value => {
            if (value) return "Sí";
            else return "No";
          }
        },
        Inicio: "inicio",
        Fin: "fin"
      },
      BttonHidden: true,
      withavances: [],
      clasificaciones: [],
      clasificacion: null,
      cargando: true,
      indicadores: [],
      fuente: "gpilarescat",
      idpunto: null,
      idclasificacion: null,
      nombrepunto: "",
      headers: [
        { text: "Código", value: "codigo", fixed: true, width: "100px" },
        { value: "nombre", text: "Nombre" },
        { value: "entidades.nombre", text: "Responsable", width: "30%" },
        {
          value: "avancemostrar",
          align: "right",
          text: "Avance",
          width: "110px"
        },
        { text: "Detalle", value: "action", sortable: false, align: "center" }
      ]
    };
  },
  created() {
    this.idclasificacion = this.$route.params.idclasificacion;
    this.idpunto = this.$route.params.idpunto;
    this.get_clasificaciones();
    this.recalcular();
    this.GetPunto({
        params: {
          idpunto: this.idpunto
        }      
    })
  },
  mounted() {},
  updated() {},
  computed: {
    ...mapGetters("barra", ["gperiodo"]),
    ...mapGetters([
      "gclasificacionesvisibles",
      "gindicadores",
      "gpuntoscategoria",
      "gfechacorte",
      "gpunto"
    ]),
    ...mapGetters({ items: ["gpilarescat"] }),
    ...mapGetters("mensaje", ["ginformation", "gnodata"]),
    totalChilds() {
      var t = this.indicadores.length;
      return t;
    },
    total() {
      return this.items.length;
    },
    itemsporpagina() {
      if (!isNaN(this.itemsPerPageSopCuan)) return this.itemsPerPageSopCuan;
      else return 1;
    }
  },
  methods: {
    ...mapActions([
      "get_clasificaciones",
      "vigenciaTodas",
      "get_pilaresbycategoria",
      "get_fechacorteclasificacion",
      "get_indicadorespuntoclasificacion",
      "GetPunto"
    ]),
    recalcular() {
      this.get_pilaresbycategoria({
        params: {
          idperiodo: this.gperiodo,
          idclasificacion: this.idclasificacion,
          idpunto: this.idpunto
        }
      });
      this.get_fechacorteclasificacion({
        params: {
          idperiodo: this.gperiodo,
          idclasificacion: this.idclasificacion
        }
      });
      this.cargarindicadores();
    },
    verdetalle(item) {
      let global = JSON.parse(unescape(process.env.PACKAGE_JSON)).global;
      let env = global[global.env];
      this.$aes.setKey(env.path.secret);
      let cifra = this.$aes.encrypt(item.idindicador.toString());
      let temporal =
        Math.random()
          .toString(36)
          .substring(2, 6) +
        cifra +
        Math.random()
          .toString(36)
          .substring(2, 6);
      console.log(temporal);
      let encrypted = this.$aes.encrypt(temporal);
      encrypted = encrypted.replace(/\//g, "AbcYq");
      encrypted = encrypted.replace(/\+/g, "qYcbA");
      this.$router.push("/detalleclasificaindicador/" + encrypted);
    },
    formato(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
      }
    },
    cambiarpunto(id) {
      this.idpunto = id;
    },
    cargarindicadores() {
      if (this.idpunto !== null) {
        this.get_indicadorespuntoclasificacion({
          params: {
            idpunto: this.idpunto,
            idclasificacion: this.idclasificacion,
            idperiodo: this.gperiodo
          }
        });
      }
    },
    seleccionarclasificacion(item) {
      this.clasificacion = item;
    },
    gotoTerritorializacionPDET()
		{
			// Nota se queman los valores de Punto y clasificador
			// se llama ese formulario desde aqui con esos valores predeterminados y no va a cambiar.
			let link = "/territorialfromClasificacionPDET"; 
      this.$router.push(link);
		}
  },
  watch: {
    gperiodo: function() {
      this.recalcular();
    },
    clasificacion: function() {
      this.recalcular();
    },
    gclasificacionesvisibles: function() {
      this.clasificaciones = this.gclasificacionesvisibles;

      this.clasificacion = this.clasificaciones.filter(
        record => record.idclasificacion == this.idclasificacion
      )[0];
      this.recalcular();
    },
    idpunto: function() {
      this.cargarindicadores(); 
    },
    gpunto: function() {
      if (this.gpunto != null)
      {
        this.nombrepunto = this.gpunto.nombrecompleto;
      }
    },
    gindicadores: function() {
      this.indicadores = this.gindicadores.filter(X=> X.idpilar != 10);
    },
    items: function() {  
      if (this.items != null) {
        this.withavances = this.items.filter(p => p.indicadores > 0);
        
        if (this.idpunto !== null) {
          let filtrado = this.items.filter(p => p.idpunto === this.idpunto);
          if (filtrado.length > 0)
          if (this.gpunto != null)
          {
            this.nombrepunto = gpunto.nombrecompleto;
          }
            
        } 
      }
      this.cargando = false;
    },

  }
};
</script>